'use client';
import cx from 'classnames';
import { useParams, usePathname } from 'next/navigation';
import { hideEquipmentInfoHeader } from '../../../constants/header-account-features';

export const SearchBarEquipmentWrapper = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const params = useParams();
  const pathname = usePathname();

  const isServiceRecommendation = hideEquipmentInfoHeader.some(
    (route) => pathname.includes(route.key) && params?.[route.id]
  );

  return (
    <div className={!isServiceRecommendation ? cx('d-flex') : cx('d-none')}>
      {children}
    </div>
  );
};
